import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { StatusService } from '@core/services/status.service';

export const statusResolver: ResolveFn<void> = () => {
  return inject(StatusService).prepareStatuses();
};
